import type { FC, RefObject, SyntheticEvent, KeyboardEvent } from "react";
import styles from "@/layout/agentChat/agentChatDrawer.module.scss";
import IconButton from "@mui/material/IconButton";
import cn from "classnames";
import { PaperPlaneTiltIcon } from "@phosphor-icons/react/PaperPlaneTilt";
import { useTranslation } from "react-i18next";

type AgentFooterProps = {
  inputRef: RefObject<HTMLInputElement | null>;
  inputValue: string;
  setInputValue: (value: string) => void;
  handleKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  canSend: boolean;
  handleSend: (e: SyntheticEvent) => void;
}

const AgentFooter: FC<AgentFooterProps> = ({inputRef, setInputValue, inputValue, canSend, handleSend, handleKeyDown}) => {
  const { t } = useTranslation("translation", { keyPrefix: "agentChat" });

  return (
    <div className={styles.footer}>
      <div className={styles.inputWrapper}>
        <input
          ref={inputRef}
          className={styles.input}
          type="text"
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={t("placeholder")}
          name="agent-chat-input"
        />
        <IconButton
          className={cn(styles.sendButton, { [styles.sendButtonDisabled]: !canSend })}
          onClick={handleSend}
          disabled={!canSend}
          aria-label={t("send")}
        >
          <PaperPlaneTiltIcon size={18} />
        </IconButton>
      </div>
    </div>
  )
}

export default AgentFooter;
